import {BrowserRouter, Routes, Route} from 'react-router-dom'
import './App.css';
import Home from './components/Home';
import Entry from './components/Entry';
import { auth, db } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth'
import SignIn from './components/SignIn';
import List from './components/List';
import EditEntry from './components/EditEntry';
import { useEffect, useState } from 'react';
import { collection, doc, getDoc, onSnapshot, setDoc, updateDoc } from 'firebase/firestore';
import ShortTerm from './components/ShortTerm';

function App() {

  const [user, loading] = useAuthState(auth)
  const [currentId, setCurrentId] = useState("")

  const [userTags, setUserTags] = useState([]);
  const presetUserTags = [ 'Confidence', 'Exams', 'Speaking', 'Listening', 'Reading', 'Writing' ]


    useEffect(() => {

      if(!user){
        return ;
      }

        const usersCollection = collection(db, "users")
        const userRef = doc(usersCollection, user.uid);

        const userRefUnsubsribe = onSnapshot(userRef, (snapShot)=>{
          const data = snapShot.data()

          if(!snapShot.exists()){
            setDoc(doc(usersCollection, user.uid), {userTags: presetUserTags} ,{merge: true})
          }

          setUserTags(data?.userTags||[]) 

        })

        if (user){
          return () => {
            // Unsubscribe when the component unmounts to prevent memory leaks
            userRefUnsubsribe();
        };
        }
       
  }, [user]);

  function createTag(tag){
    const usersCollection = collection(db, "users")
    const userDoc = doc(usersCollection, user.uid)



    if(!userTags.includes(tag)){
      updateDoc(userDoc, {userTags:[...userTags, tag]})
    }

  }

  function deleteTag(tagToRemove){
    const usersCollection = collection(db, "users")
    const userDoc = doc(usersCollection, user.uid)

    const updatedTags = userTags.filter((item)=> item !== tagToRemove)
    setUserTags(updatedTags)

  }


  if(loading) {
    return(
      <div className='main'>Loading</div>
    )
  } else {
    if (user){
      return (
    
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Home setCurrentId={setCurrentId} setUserTags={setUserTags} userTags={userTags} currentId={currentId}/>}/>
            <Route path='/entry' element={<Entry createTag={createTag} deleteTag={deleteTag} userTags={userTags}/>}/>
            <Route path='/list' element={<List setUserTags={setUserTags} userTags={userTags}  setCurrentId={setCurrentId} currentId={currentId}/>}/>
            <Route path='/shortTerm' element={<ShortTerm/>}/>
            <Route path='/edit' element={<EditEntry userTags={userTags} createTag={createTag}  currentId={currentId}/>}/>
          </Routes>
        </BrowserRouter>
    
      );} else {
        return (<SignIn/>)
      }
  }


 
}

export default App;
